module.exports = __webpack_public_path__ + "static/img/one.7964fae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guoguoImg/one.png
// module id = zIdS
// module chunks = 1